import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerSingle = ({
  selectedDate,
  onChange,
  placeholderText,
  filterDate,
  minDate,
  maxDate,
  excludeDates,
  highlightDates,
  disabled,
  className,
  ...props
}) => {
  return (
    <DatePicker
      locale={"es"}
      className={className || "form-control"}
      selected={selectedDate}
      onChange={(date) => onChange(date)}
      placeholderText={placeholderText}
      dateFormat="dd/MM/yyyy"
      onKeyDown={(e) => e.preventDefault()}
      isClearable
      filterDate={filterDate}
      minDate={minDate}
      maxDate={maxDate}
      excludeDates={excludeDates}
      highlightDates={highlightDates}
      disabled={disabled}
      {...props}
    />
  );
};

export default DatePickerSingle;
